import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import { UserData, Director } from "../types/org.type";

export interface OrgData {
  emailOfAuthorisedRepresentiative?: string;
  boardOfDirectors?: Director[];
}

export interface RegtankReattemptApproval {
  token: string;
  requestId: string;
  remark: string;
  reattemptApproval: string;
  userId: string;
  userData?: UserData[];
  organization?: OrgData;
}

const updateRegtankOnboardingReattemptApproval = async ({
  token,
  requestId,
  remark,
  reattemptApproval,
  userId,
  userData,
  organization,
}: RegtankReattemptApproval) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/users/update-reattempt-regtank-approval`,
      { requestId, remark, reattemptApproval, userId, userData, organization },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    (e as Error).message = message;
    throw e;
  }
};

export default updateRegtankOnboardingReattemptApproval;
